import { render, staticRenderFns } from "./EcommSettingsBlock.vue?vue&type=template&id=4511a94c&scoped=true"
import script from "./EcommSettingsBlock.vue?vue&type=script&lang=js"
export * from "./EcommSettingsBlock.vue?vue&type=script&lang=js"
import style0 from "./EcommSettingsBlock.vue?vue&type=style&index=0&id=4511a94c&prod&lang=scss"
import style1 from "./EcommSettingsBlock.vue?vue&type=style&index=1&id=4511a94c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4511a94c",
  null
  
)

export default component.exports